export default __webpack_public_path__ + "static/media/feature2_3.db1363d8.png";